import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

export const IdFormOther = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()
  const idForm = useWatch({ control, name: `subjectsInfo.${index1 as 0}.idsInfo.${index2 as 0}.idForm` })

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.idsInfo.${index2 as 0}.idFormOther`}
      control={control}
      rules={{
        validate: (value) =>
          !!value || idForm !== 'Other' || isAllInfoUnavailable ? undefined : Validators.required.field(value)
      }}
      render={({ field }) => (
        <FF2
          required={idForm === 'Other' && !isAllInfoUnavailable}
          field={field}
          label="Other Type"
          input={(props) => <TextInput {...props} disabled={isAllInfoUnavailable || idForm !== 'Other'} />}
        />
      )}
    />
  )
}
